import { NdrCustomerRequests } from '../../../shared/components/NdrCustomerRequests.js/CustomerRequests';

export const AdminNdrCustomerRequestTable = () => <NdrCustomerRequests isAdmin={true} />;
export const ndrRoute = '/admin/ndr';
